export default "__VITE_ASSET__BixkKWKY__"